import { render, staticRenderFns } from "./referralChain.vue?vue&type=template&id=48dc8de8&scoped=true"
import script from "./referralChain.vue?vue&type=script&lang=js"
export * from "./referralChain.vue?vue&type=script&lang=js"
import style0 from "./referralChain.vue?vue&type=style&index=0&id=48dc8de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dc8de8",
  null
  
)

export default component.exports